import { render, staticRenderFns } from "./HeadBlock.vue?vue&type=template&id=09021a80&scoped=true"
import script from "./HeadBlock.vue?vue&type=script&lang=js"
export * from "./HeadBlock.vue?vue&type=script&lang=js"
import style0 from "./HeadBlock.vue?vue&type=style&index=0&id=09021a80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09021a80",
  null
  
)

export default component.exports